<template>
  <div class="partners-page">
    <!-- 页面头部 -->
    <section class="page-hero">
      <div class="container">
        <h1 class="hero-title">渠道合作</h1>
        <p class="hero-subtitle">携手共赢，共同开创数字化未来</p>
      </div>
    </section>

    <!-- 合作优势 -->
    <section class="advantages-section">
      <div class="container">
        <h2 class="section-title">合作优势</h2>
        <p class="section-subtitle">选择雪顶科技，让您的事业更上一层楼</p>
        
        <div class="advantages-grid">
          <div class="advantage-card" v-for="advantage in advantages" :key="advantage.id">
            <div class="advantage-icon">
              <span v-html="advantage.icon"></span>
            </div>
            <h3 class="advantage-title">{{ advantage.title }}</h3>
            <p class="advantage-description">{{ advantage.description }}</p>
            <ul class="advantage-features">
              <li v-for="feature in advantage.features" :key="feature">
                <span class="feature-check">✓</span>
                {{ feature }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <!-- 合作模式 -->
    <section class="partnership-models">
      <div class="container">
        <h2 class="section-title">合作模式</h2>
        <p class="section-subtitle">多种合作方式，总有一款适合您</p>
        
        <div class="models-grid">
          <div class="model-card" v-for="model in partnershipModels" :key="model.id">
            <div class="model-header">
              <div class="model-icon">{{ model.icon }}</div>
              <h3 class="model-title">{{ model.title }}</h3>
              <span class="model-tag">{{ model.tag }}</span>
            </div>
            
            <div class="model-content">
              <p class="model-description">{{ model.description }}</p>
              
              <!-- <div class="model-benefits">
                <h4>合作收益</h4>
                <div class="benefits-list">
                  <div 
                    class="benefit-item" 
                    v-for="benefit in model.benefits" 
                    :key="benefit.type">
                    <span class="benefit-label">{{ benefit.type }}</span>
                    <span class="benefit-value">{{ benefit.value }}</span>
                  </div>
                </div>
              </div> -->
              
              <div class="model-requirements">
                <h4>申请条件</h4>
                <ul class="requirements-list">
                  <li v-for="requirement in model.requirements" :key="requirement">
                    {{ requirement }}
                  </li>
                </ul>
              </div>
              
              <button class="apply-btn" @click="applyPartnership(model)">
                立即申请
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 成功案例 -->
    <section class="success-cases">
      <div class="container">
        <h2 class="section-title">成功案例</h2>
        <p class="section-subtitle">看看我们的合作伙伴是如何成功的</p>
        
        <div class="cases-carousel">
          <div class="case-card" v-for="case_item in successCases" :key="case_item.id">
            <div class="case-header">
              <img :src="case_item.avatar" :alt="case_item.partner" class="partner-avatar">
              <div class="partner-info">
                <h3 class="partner-name">{{ case_item.partner }}</h3>
                <p class="partner-title">{{ case_item.title }}</p>
                <p class="partner-company">{{ case_item.company }}</p>
              </div>
            </div>
            
            <div class="case-content">
              <p class="case-quote">"{{ case_item.quote }}"</p>
              
              <div class="case-achievements">
                <div 
                  class="achievement-item" 
                  v-for="achievement in case_item.achievements" 
                  :key="achievement.metric">
                  <span class="achievement-value">{{ achievement.value }}</span>
                  <span class="achievement-metric">{{ achievement.metric }}</span>
                </div>
              </div>
              
              <div class="case-timeline">
                <span class="timeline-label">合作时长</span>
                <span class="timeline-value">{{ case_item.duration }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 申请流程 -->
    <section class="application-process">
      <div class="container">
        <h2 class="section-title">申请流程</h2>
        <p class="section-subtitle">简单四步，开启合作之路</p>
        
        <div class="process-steps">
          <div class="step-item" v-for="(step, index) in applicationSteps" :key="step.id">
            <div class="step-number">{{ index + 1 }}</div>
            <div class="step-content">
              <h3 class="step-title">{{ step.title }}</h3>
              <p class="step-description">{{ step.description }}</p>
              <ul class="step-details" v-if="step.details">
                <li v-for="detail in step.details" :key="detail">{{ detail }}</li>
              </ul>
            </div>
            <div class="step-connector" v-if="index < applicationSteps.length - 1"></div>
          </div>
        </div>
      </div>
    </section>

    <!-- 支持政策 -->
    <section class="support-policies">
      <div class="container">
        <h2 class="section-title">支持政策</h2>
        <p class="section-subtitle">全方位支持，助力合作伙伴成功</p>
        
        <div class="policies-grid">
          <div class="policy-card" v-for="policy in supportPolicies" :key="policy.id">
            <div class="policy-icon">{{ policy.icon }}</div>
            <h3 class="policy-title">{{ policy.title }}</h3>
            <ul class="policy-list">
              <li v-for="item in policy.items" :key="item">{{ item }}</li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <CustomerService :visible="showCustomerService" @close="showCustomerService = false" />
    
    <!-- 联系我们 -->
    <!-- <section class="contact-section">
      <div class="container">
        <div class="contact-content">
          <h2>准备开始合作了吗？</h2>
          <p>联系我们的合作专员，获取更多详细信息</p>
          
          <div class="contact-form">
            <form @submit.prevent="submitApplication">
              <div class="form-row">
                <div class="form-group">
                  <label>姓名 *</label>
                  <input type="text" v-model="applicationForm.name" required>
                </div>
                <div class="form-group">
                  <label>公司名称 *</label>
                  <input type="text" v-model="applicationForm.company" required>
                </div>
              </div>
              
              <div class="form-row">
                <div class="form-group">
                  <label>联系电话 *</label>
                  <input type="tel" v-model="applicationForm.phone" required>
                </div>
                <div class="form-group">
                  <label>邮箱地址 *</label>
                  <input type="email" v-model="applicationForm.email" required>
                </div>
              </div>
              
              <div class="form-group">
                <label>合作类型 *</label>
                <select v-model="applicationForm.partnershipType" required>
                  <option value="">请选择合作类型</option>
                  <option value="regional">区域代理</option>
                  <option value="channel">渠道分销</option>
                  <option value="technical">技术合作</option>
                  <option value="strategic">战略合作</option>
                </select>
              </div>
              
              <div class="form-group">
                <label>合作需求</label>
                <textarea v-model="applicationForm.requirements" rows="4" placeholder="请描述您的合作需求和期望..."></textarea>
              </div>
              
              <button type="submit" class="submit-btn">提交申请</button>
            </form>
          </div>
          
          <div class="contact-info">
            <div class="info-item">
              <span class="info-icon">📞</span>
              <div>
                <h4>合作热线</h4>
                <p>400-688-5235</p>
              </div>
            </div>
            <div class="info-item">
              <span class="info-icon">📧</span>
              <div>
                <h4>合作邮箱</h4>
                <p>2294788755@qq.com</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> -->
  </div>
</template>

<script>
import CustomerService from '@/components/CustomerService.vue'

export default {
  name: 'PartnersPage',
  components: {
    CustomerService
  },
  data() {
    return {
      showCustomerService: false,
      applicationForm: {
        name: '',
        company: '',
        phone: '',
        email: '',
        partnershipType: '',
        requirements: ''
      },
      advantages: [
        {
          id: 1,
          icon: '💎',
          title: '市场领先产品',
          description: '三款核心产品均为行业领先解决方案，市场需求旺盛',
          features: [
            '技术先进，功能完善',
            '市场验证，客户认可',
            '持续迭代，产品升级',
            '竞争优势明显'
          ]
        },
        // {
        //   id: 2,
        //   icon: '🚀',
        //   title: '丰厚收益回报',
        //   description: '多层级收益模式，让合作伙伴获得可观的投资回报',
        //   features: [
        //     '销售佣金最高30%',
        //     '续费分成长期收益',
        //     '奖励机制激励成长',
        //     '业绩达标额外奖励'
        //   ]
        // },
        {
          id: 3,
          icon: '🛠️',
          title: '全方位技术支持',
          description: '专业技术团队提供全程技术支持和培训',
          features: [
            '产品培训和认证',
            '技术文档和资料',
            '实施部署支持',
            '7×24小时技术响应'
          ]
        },
        {
          id: 4,
          icon: '📈',
          title: '市场推广支持',
          description: '提供营销资源和推广支持，助力业务拓展',
          features: [
            '品牌宣传素材',
            '市场活动支持',
            '线上推广配合',
            '客户资源共享'
          ]
        }
      ],
      partnershipModels: [
        {
          id: 1,
          icon: '🌟',
          title: '区域代理',
          tag: '独家授权',
          description: '获得指定区域的独家代理权，享受区域内所有业务收益',
          benefits: [
            { type: '销售佣金', value: '25-30%' },
            { type: '续费分成', value: '15-20%' },
            { type: '区域保护', value: '独家代理' },
            { type: '支持力度', value: '重点扶持' }
          ],
          requirements: [
            '具备丰富的行业资源和客户基础',
            '有专业的销售团队和技术团队',
            '年销售目标不低于500万元',
            '具备良好的商业信誉和资金实力'
          ]
        },
        {
          id: 2,
          icon: '🤝',
          title: '渠道分销',
          tag: '灵活合作',
          description: '通过现有渠道销售我们的产品，获得销售佣金和续费分成',
          benefits: [
            { type: '销售佣金', value: '15-25%' },
            { type: '续费分成', value: '10-15%' },
            { type: '入门门槛', value: '较低' },
            { type: '合作灵活', value: '多种模式' }
          ],
          requirements: [
            '拥有相关行业的客户资源',
            '具备基础的销售能力',
            '认同公司文化和产品理念',
            '承诺完成基础销售指标'
          ]
        },
        {
          id: 3,
          icon: '🔧',
          title: '技术合作',
          tag: '深度整合',
          description: '与技术公司深度合作，共同为客户提供完整解决方案',
          benefits: [
            { type: '项目分成', value: '20-40%' },
            { type: '技术授权', value: '优惠价格' },
            { type: '联合开发', value: '共享收益' },
            { type: '品牌合作', value: '互相推广' }
          ],
          requirements: [
            '具备相关技术开发能力',
            '有成功的项目实施经验',
            '技术团队规模不少于10人',
            '愿意进行深度技术整合'
          ]
        },
        // {
        //   id: 4,
        //   icon: '🏆',
        //   title: '战略合作',
        //   tag: '长期共赢',
        //   description: '与行业龙头企业建立长期战略合作关系',
        //   benefits: [
        //     { type: '定制开发', value: '优先支持' },
        //     { type: '资源共享', value: '深度合作' },
        //     { type: '市场推广', value: '联合营销' },
        //     { type: '收益分成', value: '面议' }
        //   ],
        //   requirements: [
        //     '行业内知名企业或机构',
        //     '具备丰富的行业资源',
        //     '有长期合作的战略规划',
        //     '双方价值观和发展理念一致'
        //   ]
        // }
      ],
      successCases: [
        {
          id: 1,
          partner: '李总',
          title: '区域总经理',
          company: '某数字化服务公司',
          avatar: 'https://picsum.photos/80/80?random=60',
          quote: '与雪顶科技合作一年来，我们的业务增长了400%，产品的市场认可度很高，客户满意度也很好。',
          achievements: [
            { value: '400%', metric: '业务增长' },
            { value: '200万', metric: '年收入' },
            { value: '50+', metric: '签约客户' }
          ],
          duration: '1年'
        },
        {
          id: 2,
          partner: '王经理',
          title: '销售总监',
          company: '某系统集成商',
          avatar: 'https://picsum.photos/80/80?random=61',
          quote: '雪顶科技的产品质量过硬，技术支持到位，让我们在激烈的市场竞争中占据了有利地位。',
          achievements: [
            { value: '300%', metric: '客户增长' },
            { value: '150万', metric: '年收入' },
            { value: '98%', metric: '客户满意度' }
          ],
          duration: '8个月'
        },
        {
          id: 3,
          partner: '张董事长',
          title: '董事长',
          company: '某科技有限公司',
          avatar: 'https://picsum.photos/80/80?random=62',
          quote: '选择雪顶科技作为战略合作伙伴是我们最正确的决定，共同开拓了新的市场机会。',
          achievements: [
            { value: '500万', metric: '项目金额' },
            { value: '80%', metric: '市场份额' },
            { value: '3年', metric: '合作期限' }
          ],
          duration: '2年'
        }
      ],
      applicationSteps: [
        {
          id: 1,
          title: '提交申请',
          description: '填写合作申请表，提交相关资质证明',
          details: [
            '完整填写申请表格',
            '提供公司营业执照',
            '提交团队介绍资料',
            '说明合作意向和目标'
          ]
        },
        {
          id: 2,
          title: '资质审核',
          description: '我们会对申请材料进行审核评估',
          details: [
            '核实企业资质',
            '评估合作能力',
            '审查财务状况',
            '调研市场背景'
          ]
        },
        {
          id: 3,
          title: '面谈沟通',
          description: '安排线上或线下面谈，深入了解合作需求',
          details: [
            '产品演示介绍',
            '合作模式讨论',
            '商务条款协商',
            '技术对接方案'
          ]
        },
        {
          id: 4,
          title: '签约合作',
          description: '确定合作方案，签署合作协议，正式启动合作',
          details: [
            '签署合作协议',
            '制定实施计划',
            '技术培训支持',
            '市场推广启动'
          ]
        }
      ],
      supportPolicies: [
        {
          id: 1,
          icon: '📚',
          title: '培训支持',
          items: [
            '产品技术培训',
            '销售技能培训',
            '在线学习平台',
            '认证考试体系'
          ]
        },
        {
          id: 2,
          icon: '💰',
          title: '资金支持',
          items: [
            '市场启动资金',
            '广告投放补贴',
            '首单奖励政策',
            '业绩达标奖金'
          ]
        },
        {
          id: 3,
          icon: '🎯',
          title: '市场支持',
          items: [
            '品牌宣传物料',
            '营销活动策划',
            '客户资源推荐',
            '行业展会支持'
          ]
        },
        {
          id: 4,
          icon: '⚡',
          title: '技术支持',
          items: [
            '产品定制开发',
            '技术对接支持',
            '系统部署指导',
            '运维监控服务'
          ]
        }
      ]
    }
  },
  methods: {
    applyPartnership() {
      this.showCustomerService = true
    },
    submitApplication() {
      if (this.validateForm()) {
        alert('申请提交成功！我们会尽快与您联系')
        this.resetForm()
      }
    },
    validateForm() {
      const { name, company, phone, email, partnershipType } = this.applicationForm
      if (!name || !company || !phone || !email || !partnershipType) {
        alert('请填写所有必填项')
        return false
      }
      return true
    },
    resetForm() {
      this.applicationForm = {
        name: '',
        company: '',
        phone: '',
        email: '',
        partnershipType: '',
        requirements: ''
      }
    }
  }
}
</script>

<style scoped>
.partners-page {
  padding-top: 70px;
  min-height: 100vh;
}

/* 页面头部 */
.page-hero {
  /* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); */
  background: url('https://www.tanmarket.cn/img/agent/about_bg.png') no-repeat 50% / cover;
  color: white;
  padding: 120px 0;
  text-align: center;
}

.hero-title {
  font-size: 3rem;
  font-weight: bold;
  margin-bottom: 20px;
}

.hero-subtitle {
  font-size: 1.3rem;
  opacity: 0.9;
}

/* 通用样式 */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-title {
  font-size: 2.5rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 20px;
  color: #2c3e50;
}

.section-subtitle {
  font-size: 1.2rem;
  text-align: center;
  color: #666;
  margin-bottom: 60px;
  line-height: 1.6;
}

/* 合作优势 */
.advantages-section {
  padding: 80px 0;
  background: #f8f9fa;
}

.advantages-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 40px;
}

.advantage-card {
  background: white;
  padding: 40px 30px;
  border-radius: 20px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.advantage-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15);
}

.advantage-icon {
  font-size: 3rem;
  margin-bottom: 25px;
}

.advantage-title {
  font-size: 1.4rem;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 15px;
}

.advantage-description {
  color: #666;
  line-height: 1.6;
  margin-bottom: 25px;
}

.advantage-features {
  list-style: none;
  padding: 0;

  text-align: left;
}

.advantage-features li {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
    justify-content:center;
  color: #555;
}

.feature-check {
  color: #3470ff;
  font-weight: bold;
  margin-right: 10px;
}

/* 合作模式 */
.partnership-models {
  padding: 80px 0;
}

.models-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 40px;
}

.model-card {
  background: white;
  border-radius: 20px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: all 0.3s ease;
}

.model-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
}

.model-header {
  background: linear-gradient(135deg, #3470ff, #2550d9);
  color: white;
  padding: 30px;
  text-align: center;
  position: relative;
}

.model-icon {
  font-size: 3rem;
  margin-bottom: 15px;
}

.model-title {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 10px;
}

.model-tag {
  background: rgba(255, 255, 255, 0.2);
  padding: 5px 15px;
  border-radius: 15px;
  font-size: 0.9rem;
}

.model-content {
  padding: 30px;
}

.model-description {
  color: #666;
  line-height: 1.6;
  margin-bottom: 25px;
}

.model-benefits h4,
.model-requirements h4 {
  font-size: 1.2rem;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 15px;
}

.benefits-list {
  margin-bottom: 25px;
}

.benefit-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background: #f8f9fa;
  border-radius: 8px;
  margin-bottom: 8px;
}

.benefit-label {
  color: #666;
}

.benefit-value {
  color: #3470ff;
  font-weight: bold;
}

.requirements-list {
  list-style: none;
  padding: 0;
  margin-bottom: 30px;
}

.requirements-list li {
  padding: 8px 0;
  color: #555;
  border-bottom: 1px solid #eee;
}

.apply-btn {
  width: 100%;
  background: #3470ff;
  color: white;
  border: none;
  padding: 15px;
  border-radius: 10px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.apply-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(64, 158, 255, 0.3);
}

/* 成功案例 */
.success-cases {
  padding: 80px 0;
  background: #f8f9fa;
}

.cases-carousel {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 40px;
}

.case-card {
  background: white;
  border-radius: 20px;
  padding: 30px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.case-header {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 25px;
}

.partner-avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
}

.partner-name {
  font-size: 1.3rem;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 5px;
}

.partner-title {
  color: #3470ff;
  font-weight: 500;
  margin-bottom: 3px;
}

.partner-company {
  color: #666;
  font-size: 0.9rem;
}

.case-quote {
  font-style: italic;
  color: #555;
  line-height: 1.8;
  margin-bottom: 25px;
  font-size: 1.1rem;
}

.case-achievements {
  display: flex;
  justify-content: space-around;
  margin-bottom: 20px;
  text-align: center;
}

.achievement-item {
  display: flex;
  flex-direction: column;
}

.achievement-value {
  font-size: 1.5rem;
  font-weight: bold;
  color: #3470ff;
  margin-bottom: 5px;
}

.achievement-metric {
  color: #666;
  font-size: 0.9rem;
}

.case-timeline {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.timeline-label {
  color: #666;
}

.timeline-value {
  color: #3470ff;
  font-weight: bold;
}

/* 申请流程 */
.application-process {
  padding: 80px 0;
}

.process-steps {
  display: flex;
  justify-content: space-between;
  position: relative;
  max-width: 1000px;
  margin: 0 auto;
}

.step-item {
  flex: 1;
  text-align: center;
  position: relative;
  padding: 0 20px;
}

.step-number {
  width: 60px;
  height: 60px;
  background: #3470ff;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: bold;
  margin: 0 auto 25px;
}

.step-title {
  font-size: 1.3rem;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 15px;
}

.step-description {
  color: #666;
  line-height: 1.6;
  margin-bottom: 20px;
}

.step-details {
  list-style: none;
  padding: 0;
  text-align: left;
}

.step-details li {
  color: #555;
  margin-bottom: 8px;
  /* padding-left: 20px; */
  text-align: center;
  position: relative;
}

.step-details li::before {
  content: '•';
  color: #3470ff;
  margin-right: 10px;
  /* position: absolute; */
  left: 0;
}

.step-connector {
  position: absolute;
  top: 30px;
  right: -50%;
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, #3470ff, #2550d9);
  z-index: -1;
}

/* 支持政策 */
.support-policies {
  padding: 80px 0;
  background: #f8f9fa;
}

.policies-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
}

.policy-card {
  background: white;
  padding: 40px 30px;
  border-radius: 20px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.policy-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
}

.policy-icon {
  font-size: 3rem;
  margin-bottom: 20px;
}

.policy-title {
  font-size: 1.3rem;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 20px;
}

.policy-list {
  list-style: none;
  padding: 0;
  text-align: left;
}

.policy-list li {
  color: #555;
  margin-bottom: 10px;
  justify-content: center;
  /* padding-left: 20px; */
  text-align:center;
  position: relative;
}

.policy-list li::before {
  content: '•';
  color: #3470ff;
  font-weight: bold;
  margin-right: 10px;
  /* position: absolute; */
  left: 0;
}

/* 联系我们 */
.contact-section {
  padding: 80px 0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.contact-content h2 {
  font-size: 2.5rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 20px;
}

.contact-content > p {
  font-size: 1.2rem;
  text-align: center;
  margin-bottom: 50px;
  opacity: 0.9;
}

.contact-form {
  background: rgba(255, 255, 255, 0.1);
  padding: 40px;
  border-radius: 20px;
  backdrop-filter: blur(10px);
  margin-bottom: 50px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  margin-bottom: 8px;
  font-weight: 500;
}

.form-group input,
.form-group select,
.form-group textarea {
  padding: 12px 15px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  font-size: 1rem;
}

.form-group input::placeholder,
.form-group textarea::placeholder {
  color: rgba(255, 255, 255, 0.7);
}

.submit-btn {
  width: 100%;
  background: white;
  color: #667eea;
  border: none;
  padding: 15px;
  border-radius: 10px;
  font-size: 1.1rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
}

.submit-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
}

.contact-info {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 25px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  backdrop-filter: blur(10px);
}

.info-icon {
  font-size: 2.5rem;
}

.info-item h4 {
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 8px;
}

.info-item p {
  opacity: 0.9;
  margin: 0;
}

/* 响应式设�?*/
@media (max-width: 768px) {
  .hero-title {
    font-size: 2.2rem;
  }
  
  .section-title {
    font-size: 2rem;
  }
  
  .process-steps {
    flex-direction: column;
    gap: 40px;
  }
  
  .step-connector {
    display: none;
  }
  
  .form-row {
    grid-template-columns: 1fr;
  }
  
  .contact-form {
    padding: 25px;
  }
  
  .info-item {
    flex-direction: column;
    text-align: center;
  }
  
  .case-achievements {
    flex-direction: column;
    gap: 15px;
  }
}
</style> 
 